(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 34183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(79385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 79385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/hooks/useScrollDirection.tsx
var useScrollDirection = __webpack_require__(3466);
// EXTERNAL MODULE: ./common/bit/scrollSection/index.ts + 5 modules
var scrollSection = __webpack_require__(39361);
// EXTERNAL MODULE: ./components/carModelPage/navigation/CarModelNavBar.tsx + 1 modules
var CarModelNavBar = __webpack_require__(63269);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 25 modules
var use_scroll = __webpack_require__(10521);
// EXTERNAL MODULE: ./layout/header/Header.tsx + 10 modules
var Header = __webpack_require__(43628);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/animation.ts
var animation = __webpack_require__(78373);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/bit/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(49138);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
;// CONCATENATED MODULE: ./components/aboutUs/CarWrapper.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: calc(50% - 10px);\n  margin-top: ",
        ";\n  /* width: 50%; */\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  height: 300px;\n  margin-top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: 1s;\n  :hover,\n  :focus {\n    transform: scale(1.2);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledCarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarWrapper__StyledCarWrapper",
    componentId: "sc-27835085-0"
})(_templateObject(), function(p) {
    return p.$margin && "".concat(p.$margin, "px");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarWrapper__StyledImageContainer",
    componentId: "sc-27835085-1"
})(_templateObject1());
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(NextImage/* default */.Z).withConfig({
    displayName: "CarWrapper__StyledImage",
    componentId: "sc-27835085-2"
})(_templateObject2());
var CarWrapper = function(param) {
    var title = param.title, src = param.src, link = param.link, marginTop = param.marginTop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCarWrapper, {
        $margin: marginTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                style: {
                    width: "100%",
                    height: 400
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    image: {
                        imageUrl: src,
                        alt: title
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                $color: " #101010;",
                href: link,
                $margin: 10,
                children: "למידע נוסף"
            })
        ]
    });
};
/* harmony default export */ var aboutUs_CarWrapper = (CarWrapper);

;// CONCATENATED MODULE: ./components/aboutUs/CarsContent.tsx

function CarsContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 800px;\n  margin-top: 60px;\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    CarsContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarsContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0 20px;\n"
    ]);
    CarsContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCarsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarsContent__StyledCarsContent",
    componentId: "sc-f1e187a5-0"
})(CarsContent_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledCarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarsContent__StyledCarsWrapper",
    componentId: "sc-f1e187a5-1"
})(CarsContent_templateObject1());
var CarsContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarsContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCarsWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "MX-5 (1989~)",
                    src: "/img/aboutUs/cars/cartwo.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/roadster/01/"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "Cosmo (1975～)",
                    src: "/img/aboutUs/cars/carone.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/cosmo/"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "Capella (1970～)",
                    src: "/img/aboutUs/cars/carfour.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/capella/01/",
                    marginTop: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "Savanna (1971～)",
                    src: "/img/aboutUs/cars/carthree.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/savanna/",
                    marginTop: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "Luce (1966～)",
                    src: "/img/aboutUs/cars/carsix.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/luce/",
                    marginTop: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "Cosmo Sport (1967～)",
                    src: "/img/aboutUs/cars/carfive.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/cosmo-sport/",
                    marginTop: 40
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarWrapper, {
                    title: "התלת-אופן Mazda-Go (1931～)",
                    src: "/img/aboutUs/cars/carseven.jpg",
                    link: "https://www.mazda.com/en/innovation/stories/greatcar/mazda-go/",
                    marginTop: 40
                })
            ]
        })
    });
};
/* harmony default export */ var aboutUs_CarsContent = (CarsContent);

// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
;// CONCATENATED MODULE: ./components/aboutUs/ImageWithText.tsx

function ImageWithText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    ImageWithText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImageWithText_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h6,\n  h2,\n  p {\n    color: ",
        ";\n  }\n  ",
        " {\n    width: 800px;\n    margin-top: -130px;\n    position: relative;\n    z-index: 1;\n    height: 80px;\n    margin-top: -130px;\n    max-width: 800px;\n    width: 100%;\n  }\n  ",
        " {\n    position: absolute;\n    bottom: 30px;\n    right: 20px;\n  }\n  h6 {\n    font-weight: 300;\n    letter-spacing: 0.03em;\n  }\n"
    ]);
    ImageWithText_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageWithText__StyledWrapper",
    componentId: "sc-20eb1fa7-0"
})(ImageWithText_templateObject());
var StyledTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageWithText__StyledTextWrapper",
    componentId: "sc-20eb1fa7-1"
})(ImageWithText_templateObject1(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var ImageWithText = function(param) {
    var image = param.image, title = param.title, subtitle = param.subtitle;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                        src: image
                    }),
                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextWrapper, {
                children: isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            children: subtitle
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var aboutUs_ImageWithText = (ImageWithText);

;// CONCATENATED MODULE: ./components/aboutUs/InnerContextText.tsx

function InnerContextText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #101010;\n  margin-top: 20px;\n"
    ]);
    InnerContextText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InnerContextText_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  color: #101010;\n"
    ]);
    InnerContextText_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InnerContextText_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  ",
        " {\n    flex-direction: column;\n  }\n  ",
        " {\n    gap: 20px;\n  }\n"
    ]);
    InnerContextText_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin-bottom: 20px;\n  ",
        " {\n    margin-bottom: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: 1s;\n  :hover,\n  :focus {\n    transform: scale(1.2);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "subtitle1"
}).withConfig({
    displayName: "InnerContextText__StyledSubtitle",
    componentId: "sc-a34170d7-0"
})(InnerContextText_templateObject());
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "InnerContextText__StyledText",
    componentId: "sc-a34170d7-1"
})(InnerContextText_templateObject1());
var StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InnerContextText__StyledImageWrapper",
    componentId: "sc-a34170d7-2"
})(InnerContextText_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerContextText_StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InnerContextText__StyledImageContainer",
    componentId: "sc-a34170d7-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerContextText_StyledImage = (0,styled_components_browser_esm/* default */.ZP)(NextImage/* default */.Z).withConfig({
    displayName: "InnerContextText__StyledImage",
    componentId: "sc-a34170d7-4"
})(_templateObject4());
var InnerContentText = function(param) {
    var title = param.title, description = param.description, images = param.images, imageSource = param.imageSource;
    var length = images === null || images === void 0 ? void 0 : images.length;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubtitle, {
                children: title
            }),
            description.map(function(text, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                    children: text
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                children: images ? images.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContextText_StyledImageContainer, {
                        style: {
                            width: isDesktop ? length === 3 ? "".concat(100 / 3, "%") : "50%" : "100%",
                            height: 300
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContextText_StyledImage, {
                            image: {
                                imageUrl: image,
                                alt: "story"
                            }
                        })
                    }, index);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContextText_StyledImageContainer, {
                    style: {
                        width: "100%",
                        height: 400
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContextText_StyledImage, {
                        image: {
                            imageUrl: imageSource,
                            alt: "brandStory"
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var InnerContextText = (InnerContentText);

;// CONCATENATED MODULE: ./components/aboutUs/InnterContent.tsx

function InnterContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 800px;\n  &:first-child {\n    margin-top: 60px;\n    ",
        " {\n      margin-top: 20px;\n    }\n  }\n"
    ]);
    InnterContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyleInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InnterContent__StyleInnerWrapper",
    componentId: "sc-49c320b2-0"
})(InnterContent_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var InnerContent = function(param) {
    var nevergiveupData = param.nevergiveupData, imageSource = param.imageSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleInnerWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContextText, {
            title: nevergiveupData.title,
            description: nevergiveupData.description,
            images: nevergiveupData.images,
            imageSource: imageSource
        })
    });
};
/* harmony default export */ var InnterContent = (InnerContent);

;// CONCATENATED MODULE: ./components/aboutUs/AboutUsPage.tsx

function AboutUsPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: 80px;\n  background: ",
        ";\n  section {\n    padding-bottom: 100px;\n  }\n  ",
        " {\n    padding-top: 50px;\n  }\n"
    ]);
    AboutUsPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 0.5s ease-in-out forwards;\n"
    ]);
    AboutUsPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  min-height: max-content;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    AboutUsPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutUsPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    AboutUsPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AboutUsPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  transform: ",
        ";\n  transition: ",
        ";\n  ",
        " {\n    transform: ",
        ";\n  }\n"
    ]);
    AboutUsPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var nevergiveupData = {
    upper: {
        title: "באהבה ובאומץ מהירושימה",
        description: [
            "תעוזה והרפתקה - אלו הן שתי התכונות המאפיינות כל מכונית שיוצאת מהבית של מאזדה בהירושימה שביפן. בדומה לעוף החול, הפניקס, גם הירושימה התעוררה מאבק ההפצצה האטומית. האנשים שגרו באזור התגברו על אתגרים נוראיים שוב ושוב כשהם מסרבים להפסיק לחלום על עתיד טוב יותר. אומץ וכוח סבל היו הבסיס לשיקומה של הירושימה והם מקור ההשראה של מאזדה.",
            "במאזדה מוכנים לכל אתגר בדרך ליצירת מכוניות מדהימות. קשה ככל שתהיה הדרך, לעולם לא עוצרים, לעולם לא מוותרים.", 
        ],
        images: [
            "/img/aboutUs/sectionOne/ourstory2.jpg",
            "/img/aboutUs/sectionOne/ourstory1.jpg", 
        ]
    },
    middle: {
        title: "התמודדות יצירתית עם מסע מפרך",
        description: [
            "כולם במאזדה הרפתקנים מלידה, לא מתביישים למרוד כשצריך. חושבים אחרת וצועדים קדימה, ממשיכים לשבור מוסכמות ומתמודדים עם האתגר שביצירת מכוניות שטרם נראו. האתגר מוציא את המקסימום ומעורר את החדשנות ואת היצירתיות.",
            "רוח נועזת זו מקורה בשורשים העמוקים של מאזדה, מחדר העיצוב ועד רצפת הייצור. לנסוע אל המקומות שאף אחד לא הגיע אליהם לפני כן. זוהי הנוסחה המנצחת.", 
        ]
    },
    bottom: {
        title: '"ONE MAZDA": כשמשלבים בין רעיונות חדשניים, מרגישים בניצוץ',
        description: [
            "עבודת צוות היא מילת המפתח. כולם במאזדה מחויבים לעבודת צוות משותפת; הרעיונות ומקורות ההשראה יכולים להגיע מכל אחד בחברה, וביחד הם מדליקים את להבת החדשנות.",
            'תרבות ה- "One Mazda" הזו משקפת את המבנה הייחודי של החברה. בדרך כלל הפעילויות החיוניות של יצרני הרכב, פיתוח, ייצור ושיווק, פזורות באזורים שונים. במאזדה, הכל מרוכז במקום אחד, במטה הראשי של החברה שבהירושימה. במתקן מרוכז זה, קל למעצבים, למהנדסים, לעובדי המפעל ולאנשי השיווק לפעול יחד כדי למצוא רעיונות למכוניות נפלאות.',
            'כיוון שהחברה התפתחה בכל העולם, תרבות ה-"One Mazda" והרוח הנועזת שלה יצאה את גבולות הירושימה והגיעו עד למשרדים ולמפעלים בכל העולם. זהו מסע של תעוזה והרפתקה, והמכוניות של מאזדה ימשיכו לעורר השראה ויגרמו לדופק לעלות.', 
        ],
        images: [
            "/img/aboutUs/sectionOne/ourstory4.jpg",
            "/img/aboutUs/sectionOne/ourstory3.jpg", 
        ]
    }
};
var challengesData = {
    upper: {
        title: "אגדת המנוע הרוטורי: לעשות את הבלתי אפשרי",
        description: [
            "מכוניות עם מנוע רוטורי בכבישים. זה היה האתגר המדהים שמאזדה התמודדה איתו בהצלחה לפני כמעט חמישים שנה. באותם הימים, ייצור מנוע רוטורי אמיתי המשלב בין הספק גבוה וממדים קומפקטיים היה חלום רחוק.",
            "מהנדסים בכל רחבי העולם ניסו להגשים אותו ללא הצלחה, עד שבשנת 1967 הצליח צוות מהנדסים במאזדה להגיע לפריצת דרך משמעותית. לאורך הדרך, נתקל שוב ושוב הצוות בקשיים, אך לבסוף הוא הצליח לחצות את קו הסיום עם מכונית הספורט האייקונית, ה-Cosmo. המהנדסים המוכשרים השיגו את הבלתי אפשרי והפכו לאגדה בזכות התמדה ללא פשרות, תשוקה וחדשנות.", 
        ],
        images: [
            "/img/aboutUs/sectionTwo/story2.jpg",
            "/img/aboutUs/sectionTwo/story1.jpg", 
        ]
    },
    middle: {
        title: "הניצחון בלה-מאן לאחר שפל ארוך",
        description: [
            "בשנת 1991 טלטלה מאזדה את עולם הספורט המוטורי. המאזדה 787B, שצוידה במנוע מוטורי, זכתה במרוץ 24 השעות של לה-מאן. זכייתה של מאזדה במרוץ המאתגר הזה, שבוחן את עמידותם ויעילותם של המנועים, הוא הסיפור הקלאסי של האנדרדוג.",
            "מאזדה השתתפה תחילה במרוץ שנערך בשנת 1973. היא אומנם לא הגיעה לקו הסיום אך זכתה להתמודד עם האתגר ולהביס מתחרים ותיקים. עם ניצחונה בשנת 1991, הפכה מאזדה ליצרן הרכב האסייתי הראשון והיחיד שעשה זאת. זה היה גם הניצחון הראשון למנוע הרוטורי. ושוב, ההתמדה והתשוקה של מאזדה הובילו ליצירתה של אגדה.", 
        ]
    },
    bottom: {
        title: "SKYACTIV: עוד מאה שנה, עוד חידוש",
        description: [
            "המסע של מאזדה לעבר התמדה, תשוקה וחדשנות המשיך גם במאה החדשה. בגלל הרצון לפרוץ דרכים חדשות, פותחה טכנולוגית ה-SKYACTIV, משפחה של טכנולוגיות מתקדמות המאפשרות לתעל במלואו את הפוטנציאל הטמון במנועי הבנזין והדיזל.",
            "לדוגמה, מנוע הבנזין SKYACTIV-G הגיע לרמה חדשה לגמרי של חיסכון בדלק, הספק ופליטת מזהמים הודות ליחס דחיסה של 14:1, נתון המתקבל רק במכונית מרוצים.",
            'כתבי רכב רבים ממדינות שונות בעולם אימצו את טכנולוגיית ה-SKYACTIV והעניקו לה פרסים שונים, כולל תוארי "מכונית השנה". אבל חשוב מכך, דור חדש של מכוניות זוכה לאהדת הנהגים. ההתרגשות בקרב חובבי ההגה כמו גם התשוקה של צוות המהנדסים המשיכה להאיץ את מנוע החדשנות של מאזדה.', 
        ],
        images: [
            "/img/aboutUs/sectionTwo/story4.jpg",
            "/img/aboutUs/sectionTwo/story3.jpg", 
        ]
    }
};
var manufactoringData = {
    upper: {
        title: "אומנות מעוררת השראה",
        description: [
            'כדי ליצור מכונית עם חיים משלה דרוש מגע של אומן אמיתי. ביפן הוא נקרא "טקומי", מאסטר שמשתמש בדמיון כדי להפוך מוצרים שימושיים למשהו מפתה ומהנה. ייצור רכב הוא יותר מסתם בניית אמצעי תחבורה לאנשים, הוא מתמקד ביצירת משהו חי, משהו עם נשמה. רק מכוניות עם נשמה יכולות לרתק ולענג. מכוניות כאלה נולדות רק כאשר יצירתיות פוגשת אומנות, כאשר מה שמניע את התכנון ההנדסי הוא הדמיון. במאזדה יוצקים את התשוקה והמיומנויות לתוך המכוניות כדי להגיע לשיאי היצירתיות של אומן הטקומי. מאזדה אינה מוותרת לא על הדמיון ולא על האומנות. מתוך תהליך של שלמות יצירתית באות לעולם מכוניות נפלאות.', 
        ],
        images: [
            "/img/aboutUs/sectionThree/story1.jpg",
            "/img/aboutUs/sectionThree/story2.jpg",
            "/img/aboutUs/sectionThree/story3.jpg", 
        ]
    },
    middle: {
        title: "MX-5: מציתה את הדמיון",
        description: [
            "ה-MX-5 מזקקת יותר מכל מכונית אחרת את האתוס שמאחורי מאזדה: כדי ליצור צריך דמיון. עם האצה מדהימה ובלימה עוצמתית, ה-MX-5 מעלה את הדופק ומשחררת את הדמיון כך שתרגישו שאתם ממש חלק מהמכונית. זו חוויה המאפיינת את כל דגמי מאזדה, אבל את ה-MX-5 במיוחד. מאז נחיתתה בסצנת מכוניות הספורט בשנת 1989, ה-MX-5 המשיכה ללכוד מבטים ולכבוש לבבות.",
            'בזכות כוח המשיכה העוצמתי של ה-MX-5 היא זכתה בתואר "מכונית הספורט הדו-מושבית הנמכרת ביותר" של ספר השיאים של גינס. את האדרנלין מרגישים מהרגע שנכנסים אליה.', 
        ],
        images: [
            "/img/aboutUs/sectionThree/story5.jpg",
            "/img/aboutUs/sectionThree/story4.jpg", 
        ]
    },
    bottom: {
        title: "ללכוד את היופי החייתי",
        description: [
            'יצירה המבטאת את היופי האצילי ואת העוצמה החייתית בתנועה. זהו הרעיון שמאחורי המושג KODO - שפת העיצוב של מאזדה: הנשמה שבתנועה. הרעיון הזה מזוקק באמצעות דמיון חופשי ואומנות מחושבת המשתלבות הודות לשיתוף פעולה צמוד בין המעצב, אשר משרטט את הפנטזיה על נייר, ובין אומן החימר, אשר הופך את הרעיון לצורה אמיתית. כל פרט קטנטן נחשב. תוך התמקדות ברעיון זה, צוות העיצוב חוצה את הגבולות שבין הפנטזיה והמציאות במטרה למצוא את הדרך הטובה ביותר ליצוק את "הנשמה שבתנועה" אל תוך הרכבים.', 
        ],
        images: [
            "/img/aboutUs/sectionThree/story6.jpg",
            "/img/aboutUs/sectionThree/story7.jpg", 
        ]
    }
};
var StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AboutUsPage__StyledPageWrapper",
    componentId: "sc-f072e904-0"
})(AboutUsPage_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderCarPage = (0,styled_components_browser_esm/* default */.ZP)(Header/* default */.Z).withConfig({
    displayName: "AboutUsPage__StyledHeaderCarPage",
    componentId: "sc-f072e904-1"
})(AboutUsPage_templateObject1(), function(p) {
    return p.$exit && animation/* keyFrameFadeOut */.My;
});
var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AboutUsPage__StyledPageDiv",
    componentId: "sc-f072e904-2"
})(AboutUsPage_templateObject2());
var StyledInnerContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AboutUsPage__StyledInnerContentWrapper",
    componentId: "sc-f072e904-3"
})(AboutUsPage_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledCarModelNavBar = (0,styled_components_browser_esm/* default */.ZP)(CarModelNavBar/* default */.Z).withConfig({
    displayName: "AboutUsPage__StyledCarModelNavBar",
    componentId: "sc-f072e904-4"
})(AboutUsPage_templateObject4(), function(p) {
    return p.$exit && "1251";
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "translateY(50px)";
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "translateY(80px)";
});
var AboutUsPage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var scrollDirection = (0,useScrollDirection/* useScrollDirection */.C)();
    var ref = (0,react.useState)(false), isPastThreshold = ref[0], setIsPastThreshold = ref[1];
    // Value being driven by scrolling (e.g. height)
    var thresholdY = 2 // set the scroll position where you want the state change
    ;
    var scrollY = (0,use_scroll/* useScroll */.v)().scrollY;
    (0,react.useEffect)(function() {
        return scrollY.onChange(function(latest) {
            setIsPastThreshold(latest > thresholdY);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* ScrollingProvider */.bG, {
        offset: isDesktop ? shared/* HEADER_ANIME_D */.oe : shared/* HEADER_ANIME_M */.yv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarModelNavBar, {
                    $exit: scrollDirection === "down",
                    $isPastThreshold: isPastThreshold
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderCarPage, {
                    narrow: true,
                    $exit: scrollDirection === "down"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                    title: "לעולם לא לוותר",
                    id: "nevergiveup",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_ImageWithText, {
                                image: isDesktop ? "/img/aboutUs/nevergiveup.jpg" : "/img/aboutUs/nevergiveupMobile.png",
                                title: "מסע של תעוזה והרפתקה",
                                subtitle: "לנסוע אל המקומות שאף אחד לא הגיע אליהם לפני כן"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContentWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: nevergiveupData.upper
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: nevergiveupData.middle,
                                        imageSource: "/img/aboutUs/sectionOne/brandStory.jpg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: nevergiveupData.bottom
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                    title: "להשיג את הבלתי אפשרי",
                    id: "challenges",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_ImageWithText, {
                                image: isDesktop ? "/img/aboutUs/challengesDesktop.jpg" : "/img/aboutUs/challengesMobile.png",
                                title: "דרך ארוכה ומפותלת לעבר הקדמה והתשוקה",
                                subtitle: "אגדת המנוע המוטורי, הניצחון בלה-מאן, מהפכת ה-SKYACTIV"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContentWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: challengesData.upper
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: challengesData.middle,
                                        imageSource: "/img/aboutUs/sectionTwo/story5.jpg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: challengesData.bottom
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                    title: "ליצור עם דמיון",
                    id: "manufactoring",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_ImageWithText, {
                                image: isDesktop ? "/img/aboutUs/manufactoringDesktop.jpg" : "/img/aboutUs/manufactoringMobile.png",
                                title: "כדי ליצור צריך דמיון",
                                subtitle: "בזכות כוח הדמיון, מאזדה מייצרת מכוניות עם נשמה אמיתית."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContentWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: manufactoringData.upper
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: manufactoringData.middle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnterContent, {
                                        nevergiveupData: manufactoringData.bottom
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                    title: "רכבים נפלאים",
                    id: "greatCars",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_ImageWithText, {
                                image: isDesktop ? "/img/aboutUs/greatcarsDesktop.jpg" : "/img/aboutUs/greatcarsMobile.png",
                                title: "היסטוריה של רכבים נפלאים"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_CarsContent, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var aboutUs_AboutUsPage = (AboutUsPage);

;// CONCATENATED MODULE: ./src/pages/about-us.tsx



var AboutUs = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_AboutUsPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about_us = (AboutUs);


/***/ }),

/***/ 10010:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "y4": function() { return /* binding */ addUniqueItem; }
/* harmony export */ });
/* unused harmony export moveItem */
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}




/***/ }),

/***/ 11741:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; }
/* harmony export */ });
const isBrowser = typeof document !== "undefined";




/***/ }),

/***/ 21560:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ SubscriptionManager; }
/* harmony export */ });
/* harmony import */ var _array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10010);


class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        (0,_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* .addUniqueItem */ .y4)(this.subscriptions, handler);
        return () => (0,_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* .removeItem */ .cl)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}




/***/ }),

/***/ 96681:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}




/***/ }),

/***/ 58868:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _is_browser_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11741);



const useIsomorphicLayoutEffect = _is_browser_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .j ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;




/***/ }),

/***/ 33234:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ motionValue; }
/* harmony export */ });
/* unused harmony export MotionValue */
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54735);
/* harmony import */ var popmotion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99296);
/* harmony import */ var _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21560);




const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "7.3.6";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */
        this.updateSubscribers = new _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */
        this.velocityUpdateSubscribers = new _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */
        this.renderSubscribers = new _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = (0,framesync__WEBPACK_IMPORTED_MODULE_0__/* .getFrameData */ .$B)();
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].postRender */ .ZP.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current) {
                this.updateSubscribers.notify(this.current);
            }
            // Update velocity subscribers
            if (this.velocityUpdateSubscribers.getSize()) {
                this.velocityUpdateSubscribers.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render) {
                this.renderSubscribers.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].postRender */ .ZP.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                this.velocityUpdateSubscribers.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */
    onChange(subscription) {
        return this.updateSubscribers.add(subscription);
    }
    clearListeners() {
        this.updateSubscribers.clear();
    }
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */
    onRenderRequest(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                (0,popmotion__WEBPACK_IMPORTED_MODULE_2__/* .velocityPerSecond */ .R)(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(animation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
        }).then(() => this.clearAnimation());
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    }
}
function motionValue(init) {
    return new MotionValue(init);
}




/***/ }),

/***/ 54735:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qY": function() { return /* binding */ cancelSync; },
  "ZP": function() { return /* binding */ es; },
  "iW": function() { return /* binding */ flushSync; },
  "$B": function() { return /* binding */ getFrameData; }
});

;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/on-next-frame.mjs
const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/create-render-step.mjs
function createRenderStep(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData) => {
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/index.mjs



const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const es_frame = {
    delta: 0,
    timestamp: 0,
};
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(es_frame);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(es_frame);
const processFrame = (timestamp) => {
    runNextFrame = false;
    es_frame.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - es_frame.timestamp, maxElapsed), 1);
    es_frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
const getFrameData = () => es_frame;

/* harmony default export */ var es = (sync);



/***/ }),

/***/ 99296:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ velocityPerSecond; }
/* harmony export */ });
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8369,4548,9774,2888,179], function() { return __webpack_exec__(34183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);